import Swal  from 'sweetalert2';
export class Alert {
    id: string;
    type: AlertType;
    message: string;
    autoClose: boolean;
    keepAfterRouteChange: boolean;
    fade: boolean;

    constructor(init?:Partial<Alert>) {
        Object.assign(this, init);
    }

    static alertMessage(title:string, message:string){
        Swal.fire(title,message,'info')
    }
}

export class AlertType {
    public static success="Success"
    public static error="Error"
    public static info="Info"
    public static warning="Warning"
   
   
}